module.exports = __webpack_public_path__ + "static/dane-334b35685501cdf8d216d1ca5d2278e0.svg";